import { Box } from "./index";

type ContentLayoutProps = React.ComponentProps<typeof Box> & {
  fixedWidth?: boolean;
  "data-testid"?: string;
};

export const ContentLayout = ({ fixedWidth, ...rest }: ContentLayoutProps) => {
  if (fixedWidth) {
    return <Box margin="auto" maxWidth="500px" paddingX="dt_s" {...rest} />;
  }
  return <Box paddingX="dt_s" {...rest} />;
};
